import designTokens from '@customink/design-tokens/build/js/designTokens';
var themeOptions = function (theme) { return ({
    components: {
        MuiAlert: {
            defaultProps: {},
            styleOverrides: {
                root: {
                    marginBottom: theme.spacing(0.25),
                    '&.MuiAlert-outlinedError': {
                        backgroundColor: '#FDF4F4',
                        borderColor: '#DA1E28',
                        '.MuiAlert-icon': {
                            color: '#DA1E28',
                        },
                    },
                    '&.MuiAlert-outlinedSuccess': {
                        backgroundColor: '#F4F9F5',
                        borderColor: '#198038',
                        '.MuiAlert-icon': {
                            color: '#198038',
                        },
                    },
                    '&.MuiAlert-outlinedWarning': {
                        backgroundColor: '#FEF9E8',
                        borderColor: '#F1C21B',
                        '.MuiAlert-icon': {
                            color: '#F1C21B',
                        },
                    },
                    '&.MuiAlert-outlinedInfo': {
                        backgroundColor: '#F2F6FD',
                        borderColor: '#0043CE',
                        '.MuiAlert-icon': {
                            color: '#0043CE',
                        },
                    },
                    '.MuiAlert-message': {
                        fontSize: designTokens.typography.body.long2.size.value,
                        lineHeight: designTokens.typography.body.long2.lineHeight.value,
                        color: designTokens.color.shade.black.value,
                        paddingTop: theme.spacing(1),
                        paddingBottom: theme.spacing(1),
                    },
                    '.MuiAlertTitle-root': {
                        fontSize: designTokens.typography.heading.sub.size.value,
                        fontWeight: designTokens.typography.heading.sub.fontWeight.value,
                        lineHeight: designTokens.typography.heading.sub.lineHeight.value,
                        color: designTokens.color.shade.black.value,
                        marginBottom: '0',
                        paddingTop: theme.spacing(0.25),
                        paddingBottom: theme.spacing(0.5),
                    },
                    '.MuiAlert-icon': {
                        paddingTop: theme.spacing(1),
                        svg: {
                            fontSize: designTokens.typography.icon.medium.size.value,
                            width: theme.spacing(3),
                            height: theme.spacing(3),
                        },
                    },
                    '.MuiAlert-action': {
                        paddingTop: theme.spacing(0.25),
                        '.MuiIconButton-root': {
                            fontSize: designTokens.typography.icon.medium.size.value,
                            width: theme.spacing(4),
                            height: theme.spacing(4),
                            '.MuiSvgIcon-root': {
                                color: designTokens.color.gray.obsidian.value,
                            },
                        },
                    },
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=alertTheme.js.map